import { createSelector } from '@reduxjs/toolkit';
import { fieldsByCode } from '../fields-selector-functions';
import { optionsFromFields } from '../selectors';

export const antiVirusRequirementsOptions = createSelector(fieldsByCode, function (fieldsByCode) {
  const entity = 'localUnits';
  const fields = ['alwaysActive', 'autoUpdate', 'autoScan'];
  return optionsFromFields(fieldsByCode, entity, fields);
});
